import type { ToggleProps as BaseToggleProps } from '@ur-solutions/react-components'
import type { SVGIconProps } from '@/components_deprecated/icons'
import React from 'react'
import type { ToggleIconProps } from './Toggle';
import { IconMode, Toggle } from './Toggle'
import { useTranslate } from '@ur-solutions/react-hooks'

interface ToggleProps extends BaseToggleProps {
  iconMode?: keyof typeof IconMode

  offIconProps?: ToggleIconProps
  onIconProps?: ToggleIconProps

  localOffIconProps?: SVGIconProps
  localOnIconProps?: SVGIconProps

  leftText?: string
  rightText?: string

  thumbBackground?: string

  onChange: (value: boolean) => void
  isFull?: boolean
}

export const MonthWeekToggle: React.FC<ToggleProps> = ({
  isFull = false,
  ...toggleProps
}) => {
  const translations = useTranslate({
    month: 'common.month',
    week: 'common.week',
    period: 'common.period',
  })

  const iconProps: Omit<ToggleIconProps, 'icon'> = {
    size: '1.4rem',
    type: 'solid',
    swapOpacity: true,
  }

  return (
    <Toggle
      leftText={isFull ? translations.period : translations.month}
      rightText={translations.week}
      iconMode={IconMode.textAndIcon}
      value={toggleProps.value}
      offIconProps={{
        icon: 'calendar-alt',
        ...iconProps,
        color: !toggleProps.value ? 'white' : undefined,
      }}
      onIconProps={{
        icon: 'calendar-week',
        ...iconProps,
        color: toggleProps.value ? 'white' : undefined,
      }}
      thumbBackground="secondary"
      height="3.875rem"
      disabled={toggleProps.disabled}
      onChange={toggleProps.onChange}
    />
  )
}
